

























import Vue from "vue";
import { Component } from "vue-property-decorator";
import ChangeDisplayNameButton from "@/components/shared/ChangeDisplayNameButton.vue";
import LandingPage from "@/components/Home/LandingPage.vue";
import AttendedJinroRooms from "@/components/Home/AttendedJinroRooms.vue";

@Component({
  components: {
    ChangeDisplayNameButton,
    LandingPage,
    AttendedJinroRooms,
  },
})
export default class Home extends Vue {
  get userName(): string {
    if (this.$store.state.user) {
      return this.$store.state.user.displayName;
    }
    return "";
  }
  get hasUser(): boolean {
    return !!this.$store.state.firebaseUser;
  }

  get authLink(): string {
    const defaultPath = "/auth";
    const path =
      this.$route.path !== "/"
        ? defaultPath + "?from=" + this.$route.path
        : defaultPath;
    return path;
  }
}
